import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Grid } from "swiper/modules";

import IndustrialParkCard from "./IndustrialParkCard";

function IndustrialParkList({ list, prevID, nextID }) {

    return (
        <Swiper
            spaceBetween={10}
            breakpoints={{
                0: {
                    slidesPerView: 1,
                    grid: { rows: 1, fill: 'row' }
                },
                640: {
                    slidesPerView: 1,
                    grid: { rows: 1, fill: 'row' }
                },
                768: {
                    slidesPerView: 2,
                    grid: { rows: 2, fill: 'row' }
                },
                1024: {
                    slidesPerView: 3,
                    grid: { rows: 2, fill: 'row' }
                },
            }}
            navigation={{
                prevEl: `#${prevID}`,
                nextEl: `#${nextID}`
            }}
            modules={[Grid, Navigation, Autoplay]}
        >
            {list.map((item, index) => (
                <SwiperSlide key={index} className="h-full">
                    <IndustrialParkCard data={item}/>
                </SwiperSlide>
            ))}
        </Swiper>
    );
}

export default IndustrialParkList;